import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { CalculateUnitService } from '../../services/calculate-unit.service';

@Component({
  selector: 'app-add-calculate-unit',
  templateUrl: './add-calculate-unit.component.html',
  styleUrls: ['./add-calculate-unit.component.css']
})
export class AddCalculateUnitComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];

constructor(
  protected _service: CalculateUnitService,
  protected _injector: Injector,
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    unitName: new UntypedFormControl('', [Validators.required]),
    symbol: new UntypedFormControl('', [Validators.required]),
    status: new UntypedFormControl(''),
    notes: new UntypedFormControl(''),
  });
}

ngOnInit() {
}

onShowPopup() {
  this.validationSummary.resetErrorMessages();
  this.resetForm();
  this.onReset();

  this.itemDetail.id = 0;
  this.itemDetail.status = 1;
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }
  
  this.onInsert();
}

onInsert() {
  this._service.create(this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showInsertDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showInsertDataFailed();
      this.submitting = false;
    }
  );
}
}
